import AppSection from "../../Shared/AppSection/AppSection";
import image from '../../../Assets/Backgrounds/manageAPhone.webp';
import  {ReactComponent as Btn1} from '../../../Assets/Icons/android.svg';
function Section(){
    return(
        <>
        <AppSection 
        image={image}
        title="Manage your dashboard very simple way"
        desc="Access and work with your data securely across different locations and devices. It’s always on and fully automatic."
        desc2="You can choose to synchronise your entire HostDesign cloud to one local folder or configure multiple selective syncs between folders on your computer and folders in your HostDesign cloud."
        desc3="Use shares so all of your team can work on the same files together."
        btn1={<Btn1 />}
        />
        </>
    )
};
export default Section ;